import { get } from 'lodash';
import { createSelector } from 'reselect';
import _ from 'lodash';

import { getSites } from 'State/sites/selectors';
import { ItemEnum, CreateEditTruckRouteEnum, SiteEnum } from 'Common/FieldEnum';
import { SCHOOL } from 'Common/Constants';
import { getVendorTableData } from 'State/filters/selectors';
import { makeOptionsData } from 'Common/FormHelper';

const root = state => get(state, 'TruckRouteState.createEditTruckRoute');

export const getSiteItemIds = state => get(root(state), 'siteItems', []);
export const getSiteItemsMessage = state =>
  get(root(state), 'siteItemsMessage', null);

export const getSiteItemIdsLoading = state =>
  get(root(state), 'siteItemsLoading', false);
export const getSiteItemIdsLoadingError = state =>
  get(root(state), 'siteItemsLoadingError', null);
export const getSelectedSites = state =>
  get(root(state), 'initialSelectedSites', []);
export const getSelectedVendors = state =>
  get(root(state), 'initialSelectedVendors', []);
export const getSaveLoading = state => get(root(state), 'saving', false);
export const getSaveLoadingError = state => get(root(state), 'saveError', null);
export const getSaveData = state => get(root(state), 'saved', null);
export const getSelectedTruckRouteDetailLoading = state =>
  get(root(state), 'selectedTruckRouteDetailLoading', false);
export const getSelectedTruckRouteDetailError = state =>
  get(root(state), 'selectedTruckRouteDetailError', null);
export const getSelectedTruckRouteDetail = state =>
  get(root(state), 'selectedTruckRouteDetail', null);

export const getVendorItemIdsLoading = state =>
  get(root(state), 'vendorItemsLoading', false);
export const getVendorItemIdsLoadingError = state =>
  get(root(state), 'vendorItemsLoadingError', null);
export const getTruckRouteAssignmentTypes = state =>
  get(root(state), 'truckRouteAssignmentTypes');
export const getTruckRouteAssignmentTypesLoading = state =>
  get(root(state), 'truckRouteAssignmentTypesLoading');
export const getTruckRouteAssignmentTypesLoadingError = state =>
  get(root(state), 'truckRouteAssignmentTypesLoadingError');
export const getTruckRouteTypes = state => get(root(state), 'truckRouteTypes');
export const getTruckRouteTypesLoading = state =>
  get(root(state), 'truckRouteTypesLoading');
export const getTruckRouteTypesLoadingError = state =>
  get(root(state), 'truckRouteTypesLoadingError');

export const getRearrangedSites = createSelector(
  getSites,
  getSelectedTruckRouteDetail,
  (sites, selectedTruckRoute) => {
    const cloneSites = _.filter(sites, site => {
      if (site.SiteMasterTypeId === SCHOOL) {
        return site.IsActive && site.IsLicensed;
      } else {
        return site.IsActive;
      }
    });
    if (
      selectedTruckRoute &&
      selectedTruckRoute[CreateEditTruckRouteEnum.RouteName]
    ) {
      const removedSites = _.remove(
        cloneSites,
        item =>
          selectedTruckRoute[CreateEditTruckRouteEnum.SiteIds].indexOf(
            item[SiteEnum.Id]
          ) > -1
      );
      return [...removedSites, ...cloneSites];
    } else {
      return cloneSites;
    }
  }
);

export const getGroupedSiteItemIds = createSelector(
  getSiteItemIds,
  getSelectedTruckRouteDetail,
  (items, selectedTruckRoute) => {
    if (
      selectedTruckRoute &&
      selectedTruckRoute[CreateEditTruckRouteEnum.RouteName]
    ) {
      const cloneItems = _.clone(items);
      const disabledItems = _.remove(
        cloneItems,
        item =>
          !item[CreateEditTruckRouteEnum.IsAvailable] &&
          !selectedTruckRoute[CreateEditTruckRouteEnum.ItemIds].includes(
            item[ItemEnum.ItemId]
          )
      );
      const selectedItems = _.remove(
        cloneItems,
        item =>
          item[ItemEnum.ItemId] &&
          _.findIndex(
            selectedTruckRoute[CreateEditTruckRouteEnum.ItemIds],
            id => id === item[ItemEnum.ItemId]
          ) > -1
      );
      return [
        ..._.sortBy(disabledItems, [ItemEnum.ItemCode]),
        ..._.sortBy(selectedItems, [ItemEnum.ItemCode]),
        ..._.sortBy(cloneItems, [
          CreateEditTruckRouteEnum.IsAvailable,
          ItemEnum.ItemId,
        ]),
      ];
    } else {
      return _.sortBy(items, [
        CreateEditTruckRouteEnum.IsAvailable,
        ItemEnum.ItemId,
      ]);
    }
  }
);
export const getRearrangedVendors = createSelector(
  getVendorTableData,
  getSelectedTruckRouteDetail,
  (vendors, selectedTruckRoute) => {
    const vendorsClone = _.clone(vendors);
    if (
      selectedTruckRoute &&
      selectedTruckRoute[CreateEditTruckRouteEnum.RouteName]
    ) {
      const removedSites = _.remove(
        vendorsClone,
        vendor =>
          selectedTruckRoute[CreateEditTruckRouteEnum.DistributorIds].indexOf(
            vendor[CreateEditTruckRouteEnum.Id]
          ) > -1
      );
      return [...removedSites, ...vendorsClone];
    } else {
      return vendorsClone;
    }
  }
);

export const selectTruckRouteAssignmentTypes = createSelector(
  getTruckRouteAssignmentTypes,
  truckRouteAssignmentTypes => {
    return makeOptionsData(truckRouteAssignmentTypes);
  }
);

export const selectTruckRouteTypes = createSelector(
  getTruckRouteTypes,
  truckRouteTypes =>
    _.map(truckRouteTypes, item => {
      return { value: item.Id, label: item.Description };
    })
);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/createedittruckroute/selectors.js